import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CarteirasDataGrid } from '../../organisms';
import { PageTemplate } from '../';

const CarteirasTemplate = memo(props => {
  const { initialState, state, ...restDataGridProps } = props.dataGridProps;

  return (
    <PageTemplate
      title={props.title}
      subtitle={props.subtitle}
      scrollable={true}
      headerRenderActions={props.headerRenderActions}>
      <CarteirasDataGrid
        {...restDataGridProps}
        initialState={{
          ...initialState
        }}
        state={state}
      />
    </PageTemplate>
  );
});

CarteirasTemplate.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
  readData: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default CarteirasTemplate;
